import { render, staticRenderFns } from "./Mentionslegales.vue?vue&type=template&id=d6dfd1e4&"
import script from "./Mentionslegales.vue?vue&type=script&lang=js&"
export * from "./Mentionslegales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports